import { useQueryClient } from 'react-query';
import { QUERY_KEYS, User } from '@24i/nxg-sdk-photon';
import { useState } from 'react';
import { log } from '@24i/nxg-core-utils/src/logger';

import { useUserData } from '../../../context/UserData';
import { FetchParams, FetchResult } from '../types';
import { handleError } from '../../../utils/error';

export const useUserFetch = (): FetchResult<User | null> => {
    const queryClient = useQueryClient();
    const { fetchUser } = useUserData();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);

    const fetch = async (params?: FetchParams): Promise<User | null> => {
        try {
            setIsLoading(true);
            setError(undefined);

            if (params?.forceRefresh) {
                await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.user] });
            }

            return await queryClient.fetchQuery({
                queryKey: QUERY_KEYS.user,
                queryFn: fetchUser,
            });
        } catch (e) {
            const err = handleError(e, 'Failed to fetch user data');
            setError(err);
            log('Error fetching user data: ', err);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { fetch, isLoading, error };
};
